import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

import api from '../services/api'
import visitor from '../services/visitor'
import socket from '../services/socket'
import message from '../services/message'

const userSimple = user => ({
  name: user.name,
  hex_color: user.hex_color,
  initial: user.initial,
  type: user.type,
  profile_photo_url: user.profile_photo_url || null
})

const formatMessage = message => ({
  _id: new Date().getTime(),
  object: {
    body: message.body
  },
  attachments: message.attachments,
  status: 'sending',
  type: 'messageFromCandidatePosted'
})

const state = {
  loading: false,
  inactive: false,
  connect: false,
  messenger: null,
  sendingMessage: false,
  visitor: {
    candidate: {
      name: '',
      email_address: '',
      resume: {},
      gdpr: {
        consent: false
      },
      start_id: null
    },
    options: {
        ding_muted: false,
        open: false,
    }
  },
  conversation: []
}

const getters = {
  loading: state => state.loading,
  sendingMessage: state => state.sendingMessage,
  messenger: state => state.messenger,
  candidate: state => state.visitor.candidate,
  conversation: state => state.conversation,
  conversationLength: state => () => (state.conversation.length),
  play: state => (!state.visitor.options.ding_muted && (state.inactive || !state.visitor.options.open)),
  opened: state => state.visitor.options.open,
  visitor: state => state.visitor
}

const actions = {
  getMessenger(context, companyId) {
    return api.getMessenger(companyId).then(messenger => {
      context.commit('setMessenger', messenger)
      return companyId
    }).then(id => {
      // get visitor
      // let parent know we are ready
      let _v = visitor.getVisitor(id)
      let data = {
        type: 'ready',
        payload: {
          firstVisit: _v.first_visit,
          open: _v.options.open
        }
      }
      message.send(data)

      // connect to sockets
      if (_v.candidate._id) {
        socket.emit('authenticateCandidate', { candidate_id: _v.candidate._id })
      }

    })
  },
  getVisitor(context, pageInfo) {
    let id = context.state.messenger._id
    let updatedVisitor = Object.assign({}, visitor.getVisitor(id), pageInfo)

    updatedVisitor.number_of_page_views++
    updatedVisitor.time_on_current_page = new Date().getTime()
    // updatedVisitor.number_of_visits++

    visitor.setVisitor(id, updatedVisitor)
    context.commit('setVisitor', updatedVisitor)
    if (updatedVisitor.candidate._id) {
      context.dispatch('getCandidateConversation')
    }
  },
  postCandidate(context, { positionId, candidate }) {
    return api.postCandidate({
      positionId,
      candidate
    }).then(candidate => {
      // save candidate info
      context.commit('updateVisitorCandidate', candidate)

      // connect to sockets
      socket.emit('authenticateCandidate', { candidate_id: candidate._id })
      return true
    }, e => {
      throw e
    })
  },
  postMessageFromCandidate(context, message) {
    let formatedMessage = formatMessage(message)
    let _id = formatedMessage._id
    context.commit('SENDING_MESSAGE')
    context.commit('UPDATE_CONVERSATION', formatedMessage)
    document.querySelector('#start').play()
    return api.postMessageFromCandidate({
      candidateId: context.state.visitor.candidate._id,
      message
    }).then(message => {
      context.commit('SENDING_MESSAGE_COMPLETE')
      setTimeout(() => {
        document.querySelector('#success').play()
        context.commit('UPDATE_CONVERSATION_STATE', {
          _id: _id,
          message,
          status: 'success'
        })
      }, 500)
    }, e => {
      document.querySelector('#error').play()
      context.commit('UPDATE_CONVERSATION_STATE', {
        _id: _id,
        message,
        status: 'error'
      })
    })
  },
  resendPostMessageFromCandidate(context, message) {
    let _id = message._id
    context.commit('SENDING_MESSAGE')
    let originalMessage = {
      attachments: message.attachments,
      body: message.object.body
    }
    document.querySelector('#start').play()
    return api.postMessageFromCandidate({
      candidateId: context.state.visitor.candidate._id,
      message: originalMessage
    }).then(message => {
      context.commit('SENDING_MESSAGE_COMPLETE')
      setTimeout(() => {
        document.querySelector('#success').play()
        context.commit('UPDATE_CONVERSATION_STATE', {
          _id: _id,
          message,
          status: 'success'
        })
      }, 500)
    }, e => {
      document.querySelector('#error').play()
      context.commit('UPDATE_CONVERSATION_STATE', {
        _id: _id,
        message,
        status: 'error'
      })
    })
  },
  getCandidateConversation(context) {
    let candidateId = context.state.visitor.candidate._id
    let startId = context.state.visitor.candidate.start_id
    context.commit('SET_LOADING', true)
    return api.getCandidateConversation(candidateId, startId)
      .then(conversation => {
        context.commit('SET_CONVERSATION', conversation.reverse())
        context.commit('SET_LOADING', false)
        setTimeout(function(){
          //console.log(document.querySelector('.conversation').scrollHeight)
          document.querySelector('.conversation').scrollTop = document.querySelector('.conversation').scrollHeight
        }, 1)
      }, e => {
        context.commit('SET_LOADING', false)
        console.log(e)
      })
  }

}

const mutations = {
  SET_CONNECT: (state, connect) => {
    //console.log('socket connect = ' + connect)
    state.connect = connect
  },
  SENDING_MESSAGE: state => {
    state.sendingMessage = true
  },
  SENDING_MESSAGE_COMPLETE: state => {
    state.sendingMessage = false
  },
  setMessenger (state, messenger) {
    state.messenger = messenger
  },
  setCandidateResume(state, { file_name, url } ) {
    state.visitor.candidate.resume.file_name = file_name;
    state.visitor.candidate.resume.url = url;
  },
  setVisitor(state, visitor) {
    state.visitor = visitor
  },
  UPDATE_VISITOR: (state, { breezy_portal, current_page_url }) => {
    state.visitor.breezy_portal = breezy_portal
    state.visitor.current_page_url = current_page_url
    state.visitor.time_on_current_page = new Date().getTime()
    state.visitor.number_of_page_views += 1

    visitor.setVisitor(state.messenger._id, state.visitor)
  },
  updateVisitorCandidate(state, candidate) {
    state.visitor.candidate = candidate
    visitor.setVisitor(state.messenger._id, state.visitor)
  },
  SET_INACTIVE: (state, { inactive }) => {
    state.inactive = inactive
  },
  SET_LOADING: (state, loading) => {
    state.loading = loading
  },
  SET_OPTION_OPEN: (state, { open }) => {
    state.visitor.options.open = open
    visitor.setVisitor(state.messenger._id, state.visitor)
  },
  SET_CONVERSATION: (state, conversation) => {
    state.conversation = conversation
  },
  UPDATE_CONVERSATION: (state, message) => {
    //console.log('UPDATE_CONVERSATION')
    //console.log(message)
    if (state.conversation.length <= 0) {
      state.visitor.candidate.start_id = message._id
      visitor.setVisitor(state.messenger._id, state.visitor)
    }
    state.conversation.push(message)
    setTimeout(function(){
      //console.log(document.querySelector('.conversation').scrollHeight)
      document.querySelector('.conversation').scrollTop = document.querySelector('.conversation').scrollHeight
    }, 1)

  },
  UPDATE_CONVERSATION_STATE: (state, { _id, message, status }) => {
    //console.log(message);
    let index = state.conversation.findIndex(message => (message._id === _id))
    state.conversation[index].status = status
  }
}

export default new Vuex.Store({
    state,
    getters,
    actions,
    mutations
})



// WEBPACK FOOTER //
// ./src/store/data.js